import React, {Component} from 'react';
import {connect} from 'react-redux';
import ReactDOM from 'react-dom';
import { UPDATE_USER_DATA} from "actions/actionTypes";
import config from  '../../config';
import {Form, FormGroup, Col, Button, ControlLabel, FormControl, Panel} from 'react-bootstrap';
import {   makeRequest , displayMessage  }  from 'actions';
import {validateEmail}  from 'util/Utils';

class ResetPassword extends Component {

    constructor(props) {
        super(props)
        this.state = {
            email: '',
            code: '',
            requestMade: false,
            newpassword: '',
            requestResetPasswordMade: false,
            codeSent: false
        }
    }
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    sendActivationCode(e) {
        e.preventDefault();
        var self = this;
        var email = ReactDOM.findDOMNode(this.refs.formHorizontalEmail).value;

        if (email == '' ) {

            return this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Please, specify your email address'
            });
        }
        this.setState({'requestMade': true});
        var methodData = {
            'endpoint': '/forgot-password',
            'type':'post',
            'messageCode': 'emailWithActivationCodeSent',
        };
        this.props.makeRequest({'email': email}, methodData).then(function (response) {
            console.log('response email sent', response);
            self.setState({'codeSent': true, email:email});
        }).catch(function (error) {
            console.log('in catch', error);
            self.setState({'requestMade': false});
        });
    }
    resetPassword(e) {
        e.preventDefault();
        var self = this;
        var newpassword = ReactDOM.findDOMNode(this.refs.formHorizontalNewPassword).value;
        var code = ReactDOM.findDOMNode(this.refs.formHorizontalCode).value;
         if (code == '') {
            return this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Please, specify the code received in email'
            });
        }
        if (config.getEnvironmentName() !== 'local' &&  newpassword.length < 5) {
            return this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Password should include at least 5 symbols'
            });
        }
        this.setState({'requestResetPasswordMade': true});
        var methodData = {
            'endpoint': '/reset-password',
            'messageCode': 'passwordHasBeenReset',
            'type':'post',
            'success_event':UPDATE_USER_DATA,
        };
        this.props.makeRequest({'email': this.state.email, 'password':newpassword, 'code':code}, methodData).then(function (response) {
            console.log('response email sent', response);
            self.context.router.push('/admin');
        }).catch(function (error) {

            self.setState({'requestResetPasswordMade': false});
        });
    }


    render() {
        return (
            <div >
                <Panel  header="Reset password form">
                    {this.state.codeSent ?
                        (<Form key="newpassword" horizontal onSubmit={this.resetPassword.bind(this)}>
                        <FormGroup  >
                            <Col componentClass={ControlLabel} sm={2}>
                                New password
                            </Col>
                            <Col sm={10}>
                                <FormControl type="password" ref="formHorizontalNewPassword" placeholder=""/>
                            </Col>
                        </FormGroup>
                            <FormGroup >
                                <Col componentClass={ControlLabel} sm={2}>
                                    Code received
                                </Col>
                                <Col sm={10}>
                                    <FormControl type="text" ref="formHorizontalCode" placeholder=""/>
                                </Col>
                            </FormGroup>
                        <FormGroup >
                            <Col smOffset={2} sm={10}>
                                <Button   disabled={this.state.requestResetPasswordMade} className="btn-primary" type="submit">
                                    Reset password
                                </Button>
                            </Col>
                        </FormGroup>
                    </Form>) :
                        (<Form key="email" horizontal onSubmit={this.sendActivationCode.bind(this)}>
                            <FormGroup  >
                                <Col componentClass={ControlLabel} sm={2}>
                                    Email
                                </Col>
                                <Col sm={10}>
                                    <FormControl type="email" ref="formHorizontalEmail" placeholder="Email"/>
                                </Col>
                            </FormGroup>

                            <FormGroup>
                                <Col smOffset={2} sm={10}>
                                    <Button    disabled={this.state.requestMade} className="btn-primary" type="submit">
                                        Send reset password code
                                    </Button>
                                </Col>
                            </FormGroup>
                        </Form>)


                    }
                </Panel>
            </div >
        );

    }
}

function mapStateToProps(state) {
    return { appData: state.appData  }
}

export default connect(mapStateToProps, {makeRequest,displayMessage})(ResetPassword);
